var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import StyledIcon from './StyledIcon';

var CircleCheckIcon = function CircleCheckIcon(props) {
  return React.createElement(
    StyledIcon,
    _extends({}, props, { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1755 2048' }),
    React.createElement('path', { d: 'M0 877q0-179 69.5-341.5t187-279.5 280-186.5T878 0t341.5 69.5T1499 256t186.5 279.5T1755 877t-69.5 341.5-186.5 280-279.5 187T878 1755t-341.5-69.5-280-187-187-280T0 877zm369.5 28.5Q370 929 387 945l315 308q16 16 40 16t40-16l66-67v-1l521-532q17-17 17-40.5t-17-39.5l-67-66q-17-17-40.5-16.5T1222 508l-483 492-206-203q-17-16-40-16t-40 16l-67 68q-17 17-16.5 40.5z' })
  );
};
export default CircleCheckIcon;